class TasacionesApiClient {
    constructor() {
        this.baseUrl = TasacionesConf.ajax_url;
        this.nonce = TasacionesConf.nonce;
    }

    async request(action, data = {}, options = {}) {
        const form = document.querySelector('.tasaciones-funnel-step-form');
        const contextual = ['back_sync_actions', 'update_tariff_from_catastro_surface', 'save_funnel_step'].includes(action);
        const context = contextual ? {
            tasaciones_funnel_ref: form?.querySelector('[name="tasaciones_funnel_ref"]')?.value || '',
            tasaciones_funnel_revision: form?.querySelector('[name="tasaciones_funnel_revision"]')?.value || '0',
            tasaciones_funnel_step_nonce: form?.querySelector('[name="tasaciones_funnel_step_nonce"]')?.value || '',
            tasaciones_submission_id: form?.querySelector('[name="tasaciones_submission_id"]')?.value || ''
        } : {};
        const body = new URLSearchParams({
            action,
            nonce: this.nonce,
            ...data,
            ...context
        });

        const fetchOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body
        };

        // Agregar signal si se proporciona
        if (options.signal) {
            fetchOptions.signal = options.signal;
        }

        const response = await fetch(this.baseUrl, fetchOptions);

        const result = await response.json();
        if (contextual && (form?.querySelector('[name="tasaciones_funnel_ref"]')?.value !== context.tasaciones_funnel_ref || form?.querySelector('[name="tasaciones_funnel_revision"]')?.value !== context.tasaciones_funnel_revision || (result.success && result.data?.context !== context.tasaciones_funnel_ref))) {
            throw new Error('El formulario ha cambiado. Recarga la página.');
        }
        if (contextual && result.success && result.data?.context === context.tasaciones_funnel_ref) {
            const revision = form?.querySelector('[name="tasaciones_funnel_revision"]');
            if (revision && result.data?.revision != null) revision.value = String(result.data.revision);
        }
        return result;
    }

    async parseAddress(direccion_rc, type = 'osm', options = {}) {
        return this.request('parse_direccion_rc', { direccion_rc, type }, options);
    }

    async parseOSMAddress(osm_address, options = {}) {
        // Convert array to JSON string since URLSearchParams can't handle nested arrays
        const serializedAddress = JSON.stringify(osm_address);
        return this.request('search_osm_in_catastro', { osm_address: serializedAddress }, options);
    }

    async getProvincias(query, options = {}) {
        return this.request('catastro_get_provincias', { query }, options);
    }

    async getMunicipios(provincia, query, options = {}) {
        return this.request('catastro_get_municipios', { provincia, query }, options);
    }

    async getVias(provincia, municipio, query, options = {}) {
        return this.request('catastro_get_vias', { provincia, municipio, query }, options);
    }

    async getNumeros(provincia, municipio, via, numero, options = {}) {
        // El número es el texto escrito como query porque catastro no te da todos los números del tirón, sino los cercanos.
        // Este endpoint devuelve ['found': true|false, 'rc': '', 'error': '']
        return this.request('catastro_get_numeros', { provincia, municipio, via, numero }, options);
    }

    async saveStepData(step, data, options = {}) {
        return this.request('save_funnel_step', { step, data: JSON.stringify(data) }, options);
    }

    async backSyncActions(options = {}) {
        return this.request('back_sync_actions', {}, options);
    }

    async updateTariffFromCatastroSurface(surface, source = 'catastro', options = {}) {
        return this.request('update_tariff_from_catastro_surface', { surface, source }, options);
    }
}

// Hacer la clase disponible globalmente
window.TasacionesApiClient = TasacionesApiClient;
